/** API routes for HLX provider view — registered in ~/utils/routes.ts. */

export const HLX_PROVIDER_VIEW_ROUTES = {
  get: '/hlx/provider-view/{providerId}',
};

export const HLX_PROVIDER_VIEW_BY_RESPONSE_PROVIDER_ROUTES = {
  get: '/hlx/provider-view/by-response-provider/{responseProviderId}',
};

export const HLX_PROVIDER_VIEW_BY_SERVICE_LISTING_ROUTES = {
  get: '/hlx/provider-view/by-service-listing/{serviceListingId}',
};

export const HLX_UNMASK_REQUEST_ROUTES = {
  post: '/hlx/provider-view/unmask-request/{responseId}',
};

export const HLX_UNMASK_APPROVE_ROUTES = {
  post: '/hlx/provider-view/unmask-approve/{responseId}',
};

export const HLX_UNMASK_REJECT_ROUTES = {
  post: '/hlx/provider-view/unmask-reject/{responseId}',
};

export const HLX_JOB_RESPONSE_UNMASK_REQUEST_ROUTES = {
  post: '/hlx/job-responses/{responseId}/unmask/request',
};

export const HLX_JOB_RESPONSE_UNMASK_STATE_ROUTES = {
  get: '/hlx/job-responses/{responseId}/unmask',
};

export const HLX_JOB_RESPONSE_UNMASK_APPROVE_ROUTES = {
  post: '/hlx/job-responses/{responseId}/unmask/approve',
};

export const HLX_JOB_RESPONSE_UNMASK_REJECT_ROUTES = {
  post: '/hlx/job-responses/{responseId}/unmask/reject',
};

export const HLX_JOB_RESPONSE_UNMASK_WITHDRAW_ROUTES = {
  delete: '/hlx/job-responses/{responseId}/unmask/request',
};

export const HLX_ACCEPT_ROUTES = {
  post: '/hlx/job-responses/{responseId}/accept',
};

export const HLX_ACCEPT_LISTING_ROUTES = {
  post: '/hlx/job-responses/{responseId}/accept-listing',
};
